__turbopack_context__.v({
  "CopyButton": "cekZta_CopyButton",
  "CopySuccess": "cekZta_CopySuccess",
  "Error": "cekZta_Error",
  "ErrorIcon": "cekZta_ErrorIcon",
  "ErrorList": "cekZta_ErrorList",
  "ExportSection": "cekZta_ExportSection",
  "ImportButton": "cekZta_ImportButton",
  "ImportResult": "cekZta_ImportResult",
  "ImportSection": "cekZta_ImportSection",
  "JsonTextarea": "cekZta_JsonTextarea",
  "Root": "cekZta_Root",
  "SectionHeader": "cekZta_SectionHeader",
  "SectionLabel": "cekZta_SectionLabel",
  "Success": "cekZta_Success",
  "SuccessIcon": "cekZta_SuccessIcon",
  "Tab": "cekZta_Tab",
  "TabActive": "cekZta_TabActive",
  "Tabs": "cekZta_Tabs",
  "Warning": "cekZta_Warning",
  "WarningLabel": "cekZta_WarningLabel",
  "WarningList": "cekZta_WarningList",
  "skeleton-loading": "cekZta_skeleton-loading",
});
